/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Strength_PlanInputs */

const en_portal_goal_strength_plan = /** @type {(inputs: Portal_Goal_Strength_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A strength cycle written by your coach`)
};

const pl_portal_goal_strength_plan = /** @type {(inputs: Portal_Goal_Strength_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cykl siłowy rozpisany przez trenera`)
};

/**
* | output |
* | --- |
* | "A strength cycle written by your coach" |
*
* @param {Portal_Goal_Strength_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_strength_plan = /** @type {((inputs?: Portal_Goal_Strength_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Strength_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_strength_plan(inputs)
	return en_portal_goal_strength_plan(inputs)
});